<template>
  <div>
    <a-card class="order-detail-content">
      <div class="order-detail-title-border">
        <div class="order-detail-content-title">{{ $t('租赁单_异地还箱申请列表') }}</div>
        <a-button class="order-detail-content-add_button" v-if="boxOptions.length > 0" @click="open()">
          <a-icon type="plus"/> {{ $t('租赁单_申请异地还箱') }}
        </a-button>
      </div>

      <dol-list
        style="margin-top: 10px;"
        :columns="columns"
        source="local"
        :default-data="showData"
        :row-key="'FLOW_ID'"
        :pagination="false"
        :cardFlag="false"
      >
        <template #BOX_CODE="field, record">
          <div>
            <img class="box_img" :src="BOX_ICON" />
            <a-tag class="box_code">{{field}}</a-tag>
          </div>
        </template>
        <template #status="field, record">
          {{ showStatus[field] || field }}
        </template>
      </dol-list>
    </a-card>

    <!--  申请异地还箱  -->
    <a-modal
      v-model="visible"
      :title="$t('租赁单_申请异地还箱')"
      centered
      width="60%"
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
      @ok="confirm"
    >
      <dol-form-model :model="editForm" :rules="editRule" ref="editForm">
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('city')" prop="city">
          <city-select v-model="editForm.city" :query-data="{nation: this.sheetData?.OT_XB_MASTER?.[0].D_NATION_ID, STATUS: 1}" />
        </a-form-model-item>
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="boxList">
          <template #label>
            <span>{{ $t('pleaseSelectTheCaseNumber') }}</span>
            <a-checkbox @change="checkAll">{{ $t('selectAll') }}</a-checkbox>
          </template>
          <div class="form-box-options">
            <a-checkbox-group v-model="editForm.boxList" :options="boxOptions" />
          </div>
        </a-form-model-item>
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('通用_备注')" prop="remark">
          <a-textarea v-model="editForm.remark" :auto-size="{minRows: 3}" />
        </a-form-model-item>
      </dol-form-model>
    </a-modal>
  </div>
</template>

<script>
import CitySelect from '@/components/contcircle/form/city-select.vue';
const OPERATION_CODE = {
  'delete': {title: '通用_删除', status: 1},
  'agree': {title: '通用_同意', status: 5},
  'reject': {title: '通用_拒绝', status: 6},
}

import BOX_ICON from '../../../../public/static/icon/box.svg';

export default {
  name: 'diff-city-return-list',
  components: { CitySelect },
  props: {
    masterType: {type: String, default: 'cargo'}, // 主单类型，货方订单 | 箱东订单
    sheetData: {type: Object}, // 单据数据
  },
  data () {
    return {
      BOX_ICON,

      // region 弹窗表单相关操作
      visible: false,
      editForm: { city: undefined, boxList: [], remark: '' },
      // endregion
    };
  },
  computed: {
    columns(){
      const columns = [];
      columns.push({dataIndex: 'BOX_CODE', title: this.$t('通用_箱号'), scopedSlots: {customRender: 'BOX_CODE'}});
      columns.push({dataIndex: this.$kt('CITY_NAME'), title: this.$t('city')});
      columns.push({dataIndex: this.$kt('CREATE_DATE'), title: this.$t('通用_申请时间')});
      columns.push({dataIndex: this.$kt('STATUS'), title: this.$t('通用_申请状态'), scopedSlots: {customRender: 'status'}});
      return columns;
    },
    showData(){
      if(!(this.sheetData && this.sheetData.XG_APPLY_LIST)){
        return [];
      }

      return this.sheetData.XG_APPLY_LIST.filter(item => item.STATUS !== 1);
    },
    showStatus(){
      return {
        "0": this.$t('通用_申请中'),
        "1": this.$t("通用_已删除"),
        "5": this.$t('通用_已同意'),
        "6": this.$t('通用_已拒绝'),
      }
    },
    // region 弹窗表单相关操作
    editRule(){
      return {
        city: [{required: true, message: this.$t('租赁单_请选择异地还箱城市'), trigger: ['blur', 'change']}],
        boxList: [{required: true, message: this.$t('pleaseSelectTheBox'), trigger: ['blur', 'change']}],
      };
    },
    boxOptions(){
      if(!this.sheetData.OT_XG_DETAIL || !this.sheetData.BOX_LIST){
        return [];
      }

      const hasApplyReturnBoxSet = {};
      this.sheetData.OT_XG_DETAIL.forEach(item => {
        hasApplyReturnBoxSet[item.BOX_ID] = item;
      });
      return this.sheetData.BOX_LIST.filter(item => !hasApplyReturnBoxSet[item.BOX_ID]).map(item => ({
        value: item.BOX_ID,
        label: item.BOX_CODE,
      }));
    }
    // endregion
  },
  methods: {
    // region 列表操作
    operation(record, type){
      const operation = OPERATION_CODE[type];
      if(!operation){
        return false;
      }
      this.$confirm({
        title: this.$t('sysMessage'),
        content: this.$t('通用_确认申请处理操作', {type: this.$t(operation.title)}),
        onOk: () => {
          const submitData = [{FLOW_ID: record.FLOW_ID, STATUS: operation.status, STATUS_MEMO: ''}];
          return this.$h5Api({
            type: '4091',
            data: submitData,
          }).then((resp) => {
            this.$message.success(this.$t('submitSuccess'));
            this.$emit('reload');
          });
        }
      })
    },
    // endregion

    // region 弹窗表单相关操作
    open(){
      this.editForm = { city: undefined, boxList: [], remark: '' };
      this.visible = true;
    },
    confirm(){
      return this.$refs.editForm.validate(result => {
        if(!result){
          return true;
        }

        const submitData = this.editForm.boxList.map(boxId => ({
          XB_SHEET_CODE: this.sheetData.OT_XB_MASTER[0].SHEET_CODE,
          BOX_ID: boxId,
          CITY_ID: this.editForm.city,
          MEMO: this.editForm.remark,
        }));

        return this.$h5Api({
          type: '4090',
          data: submitData,
        }).then((resp) => {
          this.$message.success(this.$t('submitSuccess'));
          this.visible = false;
          this.$emit('reload');
        });
      })
    },
    checkAll(e){
      if(e.target.checked){
        this.editForm.boxList = this.boxOptions.map(item => item.value);
      }else{
        this.editForm.boxList = [];
      }
    },
    // endregion
  }
};
</script>

<style lang="scss">
.box_img{
  height: 48px;
  width: 48px;
  margin-right: 24px;
}
</style>
